// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '@Queries/userQueries';
import RouteBuilder from '@Services/RouteBuilder';
import { ADMIN_ORG_ID } from '@Types';
import { findDefaultPath } from '@Helpers/RedirectPath';
import { useStorageOptions } from '@Hooks/useStorageOptions';

const AdminRedirect = (path: string) => <Redirect to={RouteBuilder.compute(path as any)} />;
const UserRedirect = <Redirect to={RouteBuilder.compute('cases.default')} />;
const LoginRedirect = <Redirect to={RouteBuilder.compute('login.default')} />;

const UnknownRoute = (): ReactElement => {
    const { homepage } = useStorageOptions();
    const { data } = useCurrentUser();

    if (data) {
        const { permissions = [] as string[] } = data;
        const isUserAdmin = data.organisation === ADMIN_ORG_ID;
        if (isUserAdmin && permissions) {
            const defaultPath = findDefaultPath(permissions);
            if (defaultPath) {
                return AdminRedirect(defaultPath);
            }
        }
        return homepage ? <Redirect to={homepage} /> : UserRedirect;
    }
    return LoginRedirect;
};

export default UnknownRoute;
